import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

import { ThemeProvider } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import { BrowserRouter } from 'react-router-dom';
import Routes from './routes';
import theme from './theme';

function App() {
    return <BrowserRouter>
        <Helmet title='%s | Algopays Technology'>
            <title>Algopays Technology</title>
            <meta charSet="utf-8" />
            <meta http-equiv="X-UA-Compatible" content="IE=edge" />
            <meta name="viewport" content="minimum-scale=1, initial-scale=1, width=device-width" />
            <meta name="theme-color" content="#f8f9fb" />
            <meta property="og:title" content={ process.env.REACT_APP_NAME } />
            <meta property="og:type" content="website" />
            <meta property="og:url" content="/" />
            <meta property="og:image" content="/" />
        </Helmet>
        <ThemeProvider theme={theme}>
            <Routes />
        </ThemeProvider>
    </BrowserRouter>
}

export default App;
